import { generateGroupedDateLabels } from '../helpers';

const values = [
  [
    { key: 'staffAnswered', value: '10' },
    { key: 'staffUnanswered', value: '8' },
  ],
  [
    { key: 'staffAnswered', value: '45' },
    { key: 'staffUnanswered', value: '22' },
  ],
  [
    { key: 'staffAnswered', value: '61' },
    { key: 'staffUnanswered', value: '24' },
  ],
  [
    { key: 'staffAnswered', value: '61' },
    { key: 'staffUnanswered', value: '24' },
  ],
  [
    { key: 'staffAnswered', value: '65' },
    { key: 'staffUnanswered', value: '25' },
  ],
];

const dateLabels = generateGroupedDateLabels();

export const staffTransferredCallDummyData = {
  data: dateLabels.map((name, idx) => ({
    name,
    values: values[idx],
  })),
  aggregates: {
    staffAnswered: '242',
    staffUnanswered: '103',
    followupTasksScheduling: '0',
    followupTasksOthers: '0',
  },
};
